<div class="how-to-wrapper">
  <div class="popup-wrapper" (appClickOutside)="closePopup()">
    <div class="popup-wrapper--header">
      <span class="popup-wrapper--title">How to I get involved?</span>
      <button class="popup--close" (click)="closePopup()">
        <svg class="popup--close-icon" viewBox="0 0 32 32">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.35241 5.27713C5.72062 4.90764 6.31761 4.90764 6.68582 5.27713L26.7238 25.3848C27.0921 25.7543 27.0921 26.3534 26.7238 26.7229C26.3556 27.0924 25.7587 27.0924 25.3904 26.7229L5.35241 6.61517C4.98421 6.24568 4.98421 5.64662 5.35241 5.27713Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.27616 26.6857C4.90795 26.3162 4.90795 25.7172 5.27616 25.3477L25.2772 5.27712C25.6454 4.90763 26.2424 4.90763 26.6106 5.27712C26.9788 5.64661 26.9788 6.24567 26.6106 6.61516L6.60956 26.6857C6.24135 27.0552 5.64437 27.0552 5.27616 26.6857Z"
          />
        </svg>
      </button>
    </div>

    <div class="popup-wrapper--body">
      <div class="popup-wrapper--body-in">
        <div class="how-to-container">
          <div class="how-to-item">
            <span class="how-to-item-count">1</span>
            <span class="how-to-item-title">Install your wallet</span>
            <span class="how-to-item-text"
              >Download the Chrome browser <br />extension called
              <a
                href="https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?hl=en"
                target="_blank"
                >MetaMask</a
              >
              and install it.</span
            >
            <span class="how-to-item-icon metamask-icon"></span>
          </div>
          <div class="how-to-item">
            <span class="how-to-item-count">2</span>
            <span class="how-to-item-title">Choose your tile!</span>
            <span class="how-to-item-text"
              >Select a free tile and pick your size, <br />
              up to 4x4.</span
            >
            <div class="how-to-item-tile"></div>
          </div>
          <div class="how-to-item">
            <span class="how-to-item-count">3</span>
            <span class="how-to-item-title">Choose your NFT!</span>
            <span class="how-to-item-text"
              >Select the NFT you want to place on the tile.</span
            >
            <svg
              width="30"
              height="34"
              viewBox="0 0 30 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M28.3333 22.0001C27.8913 22.0001 27.4674 22.1757 27.1548 22.4882C26.8423 22.8008 26.6667 23.2247 26.6667 23.6667V30.3334C26.5965 30.3912 26.5074 30.4209 26.4167 30.4167H3.56667C3.41667 30.3334 3.33333 30.3334 3.33333 30.3334V23.6667C3.33333 23.2247 3.15774 22.8008 2.84518 22.4882C2.53262 22.1757 2.10869 22.0001 1.66667 22.0001C1.22464 22.0001 0.800716 22.1757 0.488155 22.4882C0.175595 22.8008 0 23.2247 0 23.6667V30.3334C0.034767 31.2471 0.429088 32.11 1.0971 32.7343C1.76512 33.3586 2.65273 33.6938 3.56667 33.6667H26.4333C27.3473 33.6938 28.2349 33.3586 28.9029 32.7343C29.5709 32.11 29.9652 31.2471 30 30.3334V23.6667C30 23.2247 29.8244 22.8008 29.5118 22.4882C29.1993 22.1757 28.7754 22.0001 28.3333 22.0001Z"
                fill="#0989E6"
              />
              <path
                d="M9.51667 9.85006L13.3333 6.01673V23.6667C13.3333 24.1088 13.5089 24.5327 13.8215 24.8452C14.134 25.1578 14.558 25.3334 15 25.3334C15.442 25.3334 15.8659 25.1578 16.1785 24.8452C16.4911 24.5327 16.6667 24.1088 16.6667 23.6667V6.01673L20.4833 9.85006C20.6383 10.0063 20.8226 10.1303 21.0257 10.2149C21.2288 10.2995 21.4466 10.3431 21.6667 10.3431C21.8867 10.3431 22.1045 10.2995 22.3076 10.2149C22.5107 10.1303 22.6951 10.0063 22.85 9.85006C23.0062 9.69512 23.1302 9.51079 23.2148 9.30769C23.2994 9.10459 23.343 8.88675 23.343 8.66673C23.343 8.44671 23.2994 8.22887 23.2148 8.02577C23.1302 7.82267 23.0062 7.63833 22.85 7.4834L16.1833 0.816729C16.0213 0.66951 15.8353 0.551132 15.6333 0.466729C15.4338 0.378553 15.2181 0.333008 15 0.333008C14.7819 0.333008 14.5662 0.378553 14.3667 0.466729C14.1647 0.551132 13.9787 0.66951 13.8167 0.816729L7.15 7.4834C6.9946 7.63879 6.87134 7.82328 6.78723 8.02631C6.70313 8.22935 6.65985 8.44696 6.65985 8.66673C6.65985 8.88649 6.70313 9.10411 6.78723 9.30714C6.87134 9.51018 6.9946 9.69466 7.15 9.85006C7.3054 10.0055 7.48988 10.1287 7.69292 10.2128C7.89595 10.2969 8.11357 10.3402 8.33333 10.3402C8.5531 10.3402 8.77071 10.2969 8.97375 10.2128C9.17679 10.1287 9.36127 10.0055 9.51667 9.85006Z"
                fill="#0989E6"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
